<div class="absolute inset-0">
  <div class="container max-w-md mx-auto h-full p-3">
    <div *ngIf="!codeSent" class="grid grid-cols-1 mt-6">

      <h2>Forgot your password?</h2>
      <p class="mb-3">No worries, we'll send you instructions to reset it</p>

      <mat-form-field class="example-full-width">
        <mat-label>Email</mat-label>
        <input matInput class="w-full" type="email" [formControl]="email" name="email" required />
        <mat-error *ngIf="email.hasError('invalidEmail')">No account found</mat-error>
      </mat-form-field>

      <p *ngIf="email.hasError('invalidEmail')" class="my-3 text-muted">
        Please check that this email address is correct.
      </p>
      <p *ngIf="email.hasError('invalidEmail')" class="mb-3 text-muted">
        If you signed up using Google then we won't have a password stored for you.
        You need to sign in using the same method.
      </p>

      <button mat-button (click)="getCode()">
        Reset password
      </button>
    </div>

    <div *ngIf="codeSent" class="grid grid-cols-1 mt-6">

      <h2>Check your email</h2>
      <p class="mb-3">
        If you provided a valid address, then you should receive a code that you can enter below to reset your password
        (<a href="javascript:void()" (click)="this.codeSent = false">try again</a>)
      </p>

      <mat-form-field class="example-full-width">
        <mat-label>Code</mat-label>
        <input matInput class="w-full" type="text" [formControl]="code" name="code" autocomplete="off" required />
        <mat-error *ngIf="code.hasError('invalidCode')">That doesn't look right</mat-error>

      </mat-form-field>

      <mat-form-field class="example-full-width">
        <mat-label>New password</mat-label>
        <input matInput class="w-full" type="password" [formControl]="password" name="password" autocomplete="off" required />
        <mat-error *ngIf="password.hasError('invalid')">Password must be at least 8 characters long, and include at least one number</mat-error>
      </mat-form-field>

      <mat-form-field class="example-full-width">
        <mat-label>Confirm password</mat-label>
        <input matInput class="w-full" type="password" [formControl]="password2" name="password2" autocomplete="off" required />
        <mat-error *ngIf="password2.hasError('passwordMismatch')">Passwords do not match</mat-error>
      </mat-form-field>

      <button mat-button (click)="setPassword()">
        Reset password
      </button>
    </div>

  </div>
</div>
